import { initialContract } from '../web3';
import mcdCatAbi from 'blockchain/abi/mcd-cat.json';
import Web3 from 'web3';
import { BigNumber } from 'bignumber.js';
import { MULTICHAIN_SETUP, WAD } from 'constants/variables';
import { amountFromRad, amountFromWei } from 'utils/contract/common-function';
import { Ilks } from 'types';

const { MCD_CAT } = MULTICHAIN_SETUP.polka.address;

export const catIlks$ = async ({ ilks }: Ilks, rpc?: string) => {
  const cat = initialContract(mcdCatAbi, MCD_CAT, rpc);
  const { flip, chop, dunk }: any = await cat.methods
    .ilks(Web3.utils.utf8ToHex(ilks))
    .call();
  return {
    liquidatorAddress: flip,
    liquidationPenalty: amountFromWei(new BigNumber(chop).minus(WAD)),
    maxAuctionLotSize: amountFromRad(new BigNumber(dunk)),
  };
};
